import FlightEntry from './FlightEntry';

export default FlightEntry;
